<app-crud-create [fields]="fields" [title]="'competencia'"
  [description]="'En esta sección podrás ingresar el detalle del Título'">
</app-crud-create>
